/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { JobOccurrenceDto } from './JobOccurrenceDto';
import {
    JobOccurrenceDtoFromJSON,
    JobOccurrenceDtoFromJSONTyped,
    JobOccurrenceDtoToJSON,
} from './JobOccurrenceDto';

/**
 * 
 * @export
 * @interface ODataPostProcessedResultsOfJobOccurrenceDto
 */
export interface ODataPostProcessedResultsOfJobOccurrenceDto {
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfJobOccurrenceDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<JobOccurrenceDto>}
     * @memberof ODataPostProcessedResultsOfJobOccurrenceDto
     */
    value?: Array<JobOccurrenceDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ODataPostProcessedResultsOfJobOccurrenceDto
     */
    $type?: ODataPostProcessedResultsOfJobOccurrenceDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfJobOccurrenceDto
     */
    odataCount?: number;
}


/**
 * @export
 */
export const ODataPostProcessedResultsOfJobOccurrenceDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoODataPostProcessedResults1PtwPtw100AppZeroApplicationSharedJobExecutionDtoJobOccurrenceDtoPtwPtw100AppZeroApplicationSharedPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ODataPostProcessedResults`1[[Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.JobOccurrenceDto, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ODataPostProcessedResultsOfJobOccurrenceDtoTypeEnum = typeof ODataPostProcessedResultsOfJobOccurrenceDtoTypeEnum[keyof typeof ODataPostProcessedResultsOfJobOccurrenceDtoTypeEnum];



/**
 * Check if a given object implements the ODataPostProcessedResultsOfJobOccurrenceDto interface.
 */
export function instanceOfODataPostProcessedResultsOfJobOccurrenceDto(value?: unknown): value is ODataPostProcessedResultsOfJobOccurrenceDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ODataPostProcessedResultsOfJobOccurrenceDtoTypeEnum)[0];
}

export function ODataPostProcessedResultsOfJobOccurrenceDtoFromJSON(json: any): ODataPostProcessedResultsOfJobOccurrenceDto {
    return ODataPostProcessedResultsOfJobOccurrenceDtoFromJSONTyped(json, false);
}

export function ODataPostProcessedResultsOfJobOccurrenceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ODataPostProcessedResultsOfJobOccurrenceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'value': json['value'] == null ? undefined : ((json['value'] as Array<any>).map(JobOccurrenceDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
        'odataCount': json['@odata.count'] == null ? undefined : json['@odata.count'],
    };
}

export function ODataPostProcessedResultsOfJobOccurrenceDtoToJSON(value?: ODataPostProcessedResultsOfJobOccurrenceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'totalCount': value['totalCount'],
        'value': value['value'] == null ? undefined : ((value['value'] as Array<any>).map(JobOccurrenceDtoToJSON)),
        '$type': value['$type'],
        '@odata.count': value['odataCount'],
    });
}

